import { useFilterFields } from '@/hooks';
import { getAllValues } from '@/utils';
import { streams } from '@/utils/config';
import { useStreamingFeatureCollection } from './useStreamingFeatureCollection';
import { useStreamingVehiclesFeatureCollection } from './useStreamingVehiclesFeatureCollection';

export function useStreamingFeatureCollections(search, sort, filter) {
  const featureCollections = {
    externalVehicles: useStreamingFeatureCollection(
      'external/vehicles',
      search.externalVehicles,
      sort.externalVehicles,
      filter.externalVehicles,
      streams.includes('externalVehicles'),
    ),
    externalPeople: useStreamingFeatureCollection(
      'external/people',
      search.externalPeople,
      sort.externalPeople,
      filter.externalPeople,
      streams.includes('externalPeople'),
    ),
    vehicles: useStreamingVehiclesFeatureCollection(
      search.vehicles,
      sort.vehicles,
      filter.vehicles,
      streams.includes('vehicles'),
    ),
    locations: useStreamingFeatureCollection(
      'locations',
      search.locations,
      sort.locations,
      filter.locations,
      streams.includes('locations'),
    ),
  };
  const filterFields = useFilterFields(true);
  const filterValues = Object.entries(filterFields)
    .filter(([type]) => streams.includes(type))
    .reduce(
      (acc, [type, fields]) => ({
        ...acc,
        [type]: fields.reduce(
          (acc, field) => ({
            ...acc,
            [field]: getAllValues(featureCollections[type].features, field),
          }),
          {},
        ),
      }),
      {},
    );

  return {
    featureCollections: streams.reduce(
      (collections, key) => ({
        ...collections,
        [key]: featureCollections[key],
      }),
      {},
    ),
    filterValues: streams.reduce(
      (values, key) => ({
        ...values,
        [key]: filterValues[key],
      }),
      {},
    ),
  };
}
